import '@toast-ui/editor/dist/toastui-editor.css';
import TuiEditor from '@toast-ui/editor';
import '@toast-ui/editor/dist/i18n/pt-br';
import '@toast-ui/editor/dist/i18n/es-es';

export default TuiEditor;
